var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllCatalogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.63751V12.555C16.5 13.2825 15.9075 13.95 15.18 14.04L14.9475 14.07C13.7175 14.235 11.985 14.745 10.59 15.33C10.1025 15.5325 9.5625 15.165 9.5625 14.6325V4.20001C9.5625 3.92251 9.72 3.66751 9.9675 3.53251C11.34 2.79001 13.4175 2.13001 14.8275 2.01001H14.8725C15.7725 2.01001 16.5 2.73751 16.5 3.63751Z",
    fill: "#81878E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03243 3.53251C6.65993 2.79001 4.58243 2.13001 3.17243 2.01001H3.11993C2.21993 2.01001 1.49243 2.73751 1.49243 3.63751V12.555C1.49243 13.2825 2.08493 13.95 2.81243 14.04L3.04493 14.07C4.27493 14.235 6.00743 14.745 7.40243 15.33C7.88993 15.5325 8.42993 15.165 8.42993 14.6325V4.20001C8.42993 3.91501 8.27993 3.66751 8.03243 3.53251ZM3.74993 5.80501H5.43743C5.74493 5.80501 5.99993 6.06001 5.99993 6.36751C5.99993 6.68251 5.74493 6.93001 5.43743 6.93001H3.74993C3.44243 6.93001 3.18743 6.68251 3.18743 6.36751C3.18743 6.06001 3.44243 5.80501 3.74993 5.80501ZM5.99993 9.18001H3.74993C3.44243 9.18001 3.18743 8.93251 3.18743 8.61751C3.18743 8.31001 3.44243 8.05501 3.74993 8.05501H5.99993C6.30743 8.05501 6.56243 8.31001 6.56243 8.61751C6.56243 8.93251 6.30743 9.18001 5.99993 9.18001Z",
    fill: "#81878E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCatalogs);
export default __webpack_public_path__ + "static/media/allCatalogs.358a58ca.svg";
export { ForwardRef as ReactComponent };